module.exports = __webpack_public_path__ + "static/talona-symbol-DND3_FnP-f50cc7dfcb75b1d1130fbc8e74faa2c9.png";